const UPDATES = [
  {
    date: '07-31',
    title: '鬼灭之刃 柱训练篇 最终话今日上线',
    desc: '炭治郎与众柱迎来最终决战前的最后特训，制作水准再攀巅峰。',
    tag: '新番上线',
  },
  {
    date: '07-30',
    title: '2024暑期档票房突破80亿',
    desc: '国产电影暑期档再创佳绩，多部影片票房口碑双丰收，番茄影视即将同步上线精选片单。',
    tag: '行业动态',
  },
  {
    date: '07-29',
    title: '三体第二季预告片发布',
    desc: 'Netflix版三体第二季官方预告释出，黑暗森林法则即将揭开面纱。',
    tag: '重磅预告',
  },
  {
    date: '07-28',
    title: '繁花斩获白玉兰最佳电视剧',
    desc: '王家卫首部电视剧作品横扫白玉兰奖，胡歌获最佳男主角实至名归。',
    tag: '奖项速递',
  },
  {
    date: '07-27',
    title: '平台片库突破12万部影视资源',
    desc: '番茄影视大全持续扩展内容版图，新增大量经典老片和海外剧集资源。',
    tag: '平台公告',
  },
  {
    date: '07-26',
    title: '全站播放引擎升级完成',
    desc: '智能CDN加速和自适应码率技术全面升级，播放流畅度提升40%，卡顿率降至新低。',
    tag: '技术升级',
  },
  {
    date: '07-25',
    title: '热门短剧专区全新上线',
    desc: '响应短剧热潮，番茄影视新增短剧专区，海量热门短剧免费在线观看。',
    tag: '新品上线',
  },
  {
    date: '07-24',
    title: '移动端界面全面改版',
    desc: '手机和平板观影视体验全面优化，触控交互更流畅，界面布局更人性化。',
    tag: '产品更新',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">最新快讯</h2>
          <p className="text-sm text-foreground-500 mt-2">番茄影视最新动态与影视行业热点速递</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {UPDATES.map((item, idx) => (
            <div
              key={idx}
              className="flex gap-4 py-4 border-b border-background-200/70 last:border-0 group cursor-pointer hover:bg-background-50/50 -mx-4 px-4 rounded-lg transition-colors"
            >
              <div className="shrink-0 w-14 text-center">
                <div className="text-xs font-bold text-primary-500 bg-primary-100/70 rounded-lg py-1.5 px-1">
                  {item.date}
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className="text-[10px] font-semibold text-accent-600 bg-accent-100/80 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                  <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}